import { Clock, Facebook, Mail, MapPin, Phone, ShieldCheck, Star } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "./Nav";

export default function Footer() {
  return (
    <footer className="relative pt-20 md:pt-28 overflow-hidden" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 pb-16 md:pb-20">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Phone className="w-4 h-4 text-[#FF6B00]" />
              <p className="font-mono-tech text-xs uppercase tracking-[0.25em] text-zinc-500">
                Call Anytime
              </p>
            </div>
            <a
              href={PHONE_TEL}
              className="font-display font-semibold text-2xl hover:text-[#FF6B00] transition-colors duration-300"
              data-testid="footer-phone-link"
            >
              {PHONE_DISPLAY}
            </a>
            <a
              href="mailto:tnhvac2026@gmail.com"
              className="mt-4 inline-flex items-center gap-2 text-zinc-400 hover:text-[#FF6B00] text-sm transition-colors duration-300"
              data-testid="footer-email-link"
            >
              <Mail className="w-4 h-4 text-[#FF6B00]" />
              tnhvac2026@gmail.com
            </a>
          </div>
          <div>
            <div className="flex items-center gap-2 mb-4">
              <MapPin className="w-4 h-4 text-[#FF6B00]" />
              <p className="font-mono-tech text-xs uppercase tracking-[0.25em] text-zinc-500">
                Service Area
              </p>
            </div>
            <p className="text-zinc-300" data-testid="footer-service-area">
              Knoxville — Maryville
              <br />
              Proudly serving East TN
            </p>
          </div>
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Clock className="w-4 h-4 text-[#FF6B00]" />
              <p className="font-mono-tech text-xs uppercase tracking-[0.25em] text-zinc-500">
                Hours
              </p>
            </div>
            <p className="text-zinc-300" data-testid="footer-hours">
              Open 24 Hours
              <br />
              7 Days A Week
            </p>
          </div>
          <div>
            <div className="flex items-center gap-2 mb-4">
              <ShieldCheck className="w-4 h-4 text-[#FF6B00]" />
              <p className="font-mono-tech text-xs uppercase tracking-[0.25em] text-zinc-500">
                Trust
              </p>
            </div>
            <p className="text-zinc-300 mb-4">Licensed &amp; Insured — 4.8★ on Google</p>
            <div className="flex flex-col items-start gap-3">
              <a
                href="https://share.google/3PAD0QU9c7jXOKj3E"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 border border-white/15 hover:border-[#FF6B00] hover:text-[#FF6B00] px-4 py-2 rounded-sm text-sm transition-colors duration-300"
                data-testid="footer-google-link"
              >
                <Star className="w-4 h-4" />
                Google Reviews
              </a>
              <a
                href="https://www.facebook.com/share/18F1X51zkr/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 border border-white/15 hover:border-[#FF6B00] hover:text-[#FF6B00] px-4 py-2 rounded-sm text-sm transition-colors duration-300"
                data-testid="footer-facebook-link"
              >
                <Facebook className="w-4 h-4" />
                Follow on Facebook
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <h2
          className="font-display font-bold uppercase text-center leading-none text-[18vw] lg:text-[14rem] text-outline select-none py-6"
          data-testid="footer-giant-logo"
        >
          TN HVAC
        </h2>
      </div>

      <div className="border-t border-white/10 py-6">
        <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-zinc-600">
            © {new Date().getFullYear()} TN HVAC — Heating &amp; Cooling
          </p>
          <p className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-zinc-600">
            Comfort You Can Count On.
          </p>
        </div>
      </div>
    </footer>
  );
}
